import React, { Component } from 'react'
// import { storeData } from '../../storeData'
import './Navbar.css'

export default class Navbar extends Component {
  render() {
    const {storeData} = this.props
    return (
      <div className='Navbar'>
        <div className='Navbar_logo'><a href="/">{storeData.name}</a></div>
      </div>
    )
  }
}
